// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 7952) return "static/chunks/7952-fe94a03ef1544a7c.js";
	if (chunkId === 5973) return "static/chunks/5973-2cc64f1aeb431d5a.js";
	// return url for filenames based on template
	return "static/chunks/" + {"3496":"graphql-print","4254":"56c12eb5","5970":"lottie"}[chunkId] + "." + {"3496":"7ef39872c8b54dd4","4254":"cfaf0f642ce9413b","5970":"b7d77b1b9bc21f3d"}[chunkId] + ".js";
};